module.exports = __webpack_public_path__ + "static/media/KFC23-BANNER-LANDSCAPE-LIGHT-min.56bd911b.jpg";